<template>
    <TheModal @close="close">
        <template v-slot:head>
            Редактирование загрузки автомата
        </template>

        <ValidationObserver ref="obs" v-slot="{ invalid }" tag="form" class="form-thin" @submit.prevent="submit">
            <FormVmLoading :loading="loading" @change="change" />

            <div v-if="loading.length" class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center pt-3">
                <div>
                    <button :disabled="invalid || pending" type="submit" class="btn btn-lg-192 btn-primary mr-sm-3 mb-3 mb-sm-0">Сохранить изменения</button>
                    <button type="button" class="btn btn-lg-192 btn-outline-primary" @click="cancel">Отменить</button>
                </div>

                <button type="button" class="btn btn-outline-primary d-none d-sm-block" @click="loadToMax">
                    <i class="tlm-icon-upload" /> &nbsp; Загрузить все на 100%
                </button>
            </div>
        </ValidationObserver>
    </TheModal>
</template>

<script>
import TheModal from '@/components/TheModal'
import FormVmLoading from '@/components/FormVmLoading'

import store from '@/store'

import { ValidationObserver } from 'vee-validate'

import { toastSuccess, toastError } from '@/dialogs'

function copy(loading) {
    return loading.map(item => {
        return {
            ...item,
            add: 0
        }
    })
}

export default {
    components: {
        TheModal,
        FormVmLoading,
        ValidationObserver
    },

    data() {
        return {
            loading: copy(store.getters['vm/loading']),
            pending: false
        }
    },

    computed: {
        currentLoading() {
            return store.getters['vm/loading']
        }
    },

    watch: {
        currentLoading: {
            deep: true,
            handler(value) {
                this.loading = copy(value)
            }
        }
    },

    methods: {
        async submit() {
            const isValid = await this.$refs.obs.validate()

            if (!isValid) {
                return
            }

            const response = await this.$store.dispatch('vm/loading/save', {
                vmId: this.$route.params.id,
                loading: this.loading
            })

            response
                ? toastSuccess('Загружено')
                : toastError('Ошибка')

            if (response) {
                this.close()
            }
        },

        change([ item, add ]) {
            const index = this.loading.findIndex(i => {
                return i.id === item.id && i.product_number === item.product_number
            })

            if (index !== -1) {
                this.loading[index].add = add
            }
        },

        loadToMax() {
            this.loading.forEach(item => { item.add = item.max - item.current_loading })
        },

        cancel() {
            this.loading.forEach(item => { item.add = 0 })
            this.$refs.obs.reset()
        },

        close() {
            this.$router.push({ name: 'vm', params: this.$route.params.id })
        }
    },

    async beforeRouteEnter(to, from, next) {
        const done = await store.dispatch('vm/loading/fetch', to.params.id)

        return done ? next() : next({ name: 'vms' })
    }
}
</script>
